import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  tr: {
    home: "Anasayfa", products: "Ürünler", fairs: "Fuarlar", news: "Haberler",
    about: "Hakkımızda", contact: "İletişim", catalog: "Katalog", register: "Kayıt Olun",
    admin: "Yönetim", logout: "Çıkış", vision: "Vizyonumuz", mission: "Misyonumuz",
    discover: "Koleksiyonu Keşfet", allProducts: "Tüm Koleksiyon",
    catalogGate: "Katalog Erişimi", username: "Kullanıcı Adı", password: "Şifre",
    login: "Giriş Yap", registerTitle: "Bayi Kayıt Formu",
    firstName: "İsim", lastName: "Soyisim", email: "E-posta", phone: "Telefon",
    company: "Firma İsmi", country: "Ülke", city: "Şehir", submit: "Kaydol",
    thanks: "Ekibimiz size ulaşacak", close: "Kapat", download: "Kataloğu Görüntüle",
    noItems: "Henüz içerik eklenmedi.", readMore: "Devamını Oku",
    catalogIntro: "Kataloglarımız yalnızca yetkili bayilerimize açıktır. Giriş bilgileriniz yoksa kayıt olun.",
    address: "Adres", sendMsg: "Bize Yazın", loading: "Yükleniyor...",
    heroCta: "Katalog", contactUs: "İletişime Geçin",
  },
  en: {
    home: "Home", products: "Products", fairs: "Fairs", news: "News",
    about: "About", contact: "Contact", catalog: "Catalogue", register: "Register",
    admin: "Admin", logout: "Log out", vision: "Our Vision", mission: "Our Mission",
    discover: "Discover the Collection", allProducts: "Full Collection",
    catalogGate: "Catalogue Access", username: "Username", password: "Password",
    login: "Sign in", registerTitle: "Dealer Registration",
    firstName: "First Name", lastName: "Last Name", email: "E-mail", phone: "Phone",
    company: "Company", country: "Country", city: "City", submit: "Register",
    thanks: "Our team will contact you", close: "Close", download: "View Catalogue",
    noItems: "No content yet.", readMore: "Read more",
    catalogIntro: "Our catalogues are reserved for authorised dealers. Register if you have no credentials.",
    address: "Address", sendMsg: "Write to us", loading: "Loading...",
    heroCta: "Catalogue", contactUs: "Get in touch",
  },
  de: {
    home: "Startseite", products: "Produkte", fairs: "Messen", news: "Neuigkeiten",
    about: "Über uns", contact: "Kontakt", catalog: "Katalog", register: "Registrieren",
    admin: "Verwaltung", logout: "Abmelden", vision: "Unsere Vision", mission: "Unsere Mission",
    discover: "Kollektion entdecken", allProducts: "Gesamte Kollektion",
    catalogGate: "Katalogzugang", username: "Benutzername", password: "Passwort",
    login: "Anmelden", registerTitle: "Händler-Registrierung",
    firstName: "Vorname", lastName: "Nachname", email: "E-Mail", phone: "Telefon",
    company: "Firma", country: "Land", city: "Stadt", submit: "Registrieren",
    thanks: "Unser Team wird Sie kontaktieren", close: "Schließen", download: "Katalog ansehen",
    noItems: "Noch kein Inhalt.", readMore: "Weiterlesen",
    catalogIntro: "Unsere Kataloge sind autorisierten Händlern vorbehalten. Registrieren Sie sich.",
    address: "Adresse", sendMsg: "Schreiben Sie uns", loading: "Lädt...",
    heroCta: "Katalog", contactUs: "Kontakt aufnehmen",
  },
};

const Ctx = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem("bedas_lang") || "tr");
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("bedas_user");
    return raw ? JSON.parse(raw) : null;
  });

  useEffect(() => localStorage.setItem("bedas_lang", lang), [lang]);

  const login = (token, u) => {
    localStorage.setItem("bedas_token", token);
    localStorage.setItem("bedas_user", JSON.stringify(u));
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("bedas_token");
    localStorage.removeItem("bedas_user");
    setUser(null);
  };

  const t = (key) => DICT[lang][key] || DICT.tr[key] || key;
  const loc = (obj) => {
    if (!obj) return "";
    if (typeof obj === "string") return obj;
    return obj[lang] || obj.tr || obj.en || "";
  };

  return (
    <Ctx.Provider value={{ lang, setLang, t, loc, user, login, logout }}>
      {children}
    </Ctx.Provider>
  );
};

export const useApp = () => useContext(Ctx);
